import { ActionReducerMap } from '@ngrx/store';

import * as fromSapGlobal from './sap-globals';
import * as fromSapSynchronization from './sap-synchronization';
import * as fromSapAssets from './sap-assets';
import * as fromProfile from './profile';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { SapAssetsState } from '../models/reducers/sap-assets';

export interface AppState {
  router: RouterReducerState;
  [fromProfile.name]: fromProfile.ProfileState;
  [fromSapAssets.name]: SapAssetsState;
  [fromSapGlobal.name]: fromSapGlobal.SapGlobalState;
  [fromSapSynchronization.name]: fromSapSynchronization.SapSynchronizationState;
}

export const reducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  [fromProfile.name]: fromProfile.reducer,
  [fromSapAssets.name]: fromSapAssets.reducer,
  [fromSapGlobal.name]: fromSapGlobal.reducer,
  [fromSapSynchronization.name]: fromSapSynchronization.reducer,
};

